import classnames from 'classnames';
import React from 'react';
import styles from "./ResetButton.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Button with clean styling
 * @param other
 * @constructor
 */
export const ResetButton = /*#__PURE__*/React.forwardRef(({
  className,
  ...other
}, ref) => {
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: classnames(className, styles.resetButton),
    ref: ref,
    ...other
  });
});